module.exports = "/img/robot.cb48a907.png";